import axios from "axios";
import { store } from "./store/store";
export const coreInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL
});

export const merchantInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_MERCHANT_URL
});

merchantInstance.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

merchantInstance.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false || response.data.msg == false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data;
}, function (error) {
  store.dispatch("disconnectNetwork", error);
  return Promise.reject(error);
});

export const globalAxios = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL
});

globalAxios.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

globalAxios.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data
}, function (error) {
  store.dispatch("disconnectNetwork", error);
  return Promise.reject(error);
});


export const axiosSolve = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL
});


export const axiosPath = axios.create({
  baseURL: ""
});

export const imagePath = {
  baseURL: ""
};

export const backendVersion = {
  version: "api/v" + process.env.VUE_APP_BACKEND_API_VERSION
};



export const managerInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_MANAGER_URL
});

managerInstance.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

managerInstance.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data;
}, function (error) {
  store.dispatch("disconnectNetwork", error);
  return Promise.reject(error);
});

export const wellnessAxios = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_WELLNESS_URL
});

wellnessAxios.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

wellnessAxios.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data
}, function (error) {
  store.dispatch("disconnectNetwork", error);
  return Promise.reject(error);
});


export const dineInAxios = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_DINEIN_URL
});

dineInAxios.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

dineInAxios.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data
}, function (error) {
  store.dispatch("disconnectNetwork", error);
  return Promise.reject(error);
});


export const hotelServiceInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_HOTEL_SERVICE_URL
});

hotelServiceInstance.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

hotelServiceInstance.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data
}, function (error) {
  store.dispatch("disconnectNetwork", error);
  return Promise.reject(error);
});